// findsecrets-ignore-file

import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_PURCHASE_ORDERS_REFRESH: createSagaAction('JOB_SITE_PURCHASE_ORDERS_REFRESH'),

  JOB_SITE_PURCHASE_ORDER_CREATE: createSagaAction('JOB_SITE_PURCHASE_ORDER_CREATE'),
  JOB_SITE_PURCHASE_ORDER_UPDATE: createSagaAction('JOB_SITE_PURCHASE_ORDER_UPDATE'),
  JOB_SITE_PURCHASE_ORDER_DELETE: createSagaAction('JOB_SITE_PURCHASE_ORDER_DELETE'),
  GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID: createSagaAction('GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID')
}

// Action Creators
export const actions = {
  jobSitePurchaseOrdersRefresh: ({ jobId }) => ({
    type: constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.ACTION,
    jobId
  }),

  getPurchaseOrderByOrganizationId: ({ organizationId }) => ({
    type: constants.GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID.ACTION,
    organizationId
  }),

  createJobSitePurchaseOrder: ({ jobId, description, files, userId }) => ({
    type: constants.JOB_SITE_PURCHASE_ORDER_CREATE.ACTION,
    jobId,
    description,
    files,
    userId
  }),

  updateJobSitePurchaseOrder: ({ jobId, attachmentId, userId, description, files }) => ({
    type: constants.JOB_SITE_PURCHASE_ORDER_UPDATE.ACTION,
    jobId,
    attachmentId,
    userId,
    description,
    files
  }),

  deleteJobSitePurchaseOrder: ({ attachmentId, jobId }) => ({
    type: constants.JOB_SITE_PURCHASE_ORDER_DELETE.ACTION,
    jobId,
    attachmentId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSitePurchaseOrders: action.payload
      }
    case constants.GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID.SUCCESS:
      return {
        ...state,
        purchaseOrders: action.purchaseOrders
      }
    case constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_PURCHASE_ORDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_PURCHASE_ORDER_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_PURCHASE_ORDER_DELETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSitePurchaseOrderActions.js